/**
 * OnOff Style02 - Stitch v2: Power State + large power button (orange accent)
 * 互動：點擊時樂觀更新（localOverride），再呼叫 onCommand 與 traits 連動
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import './OnOffStyle02.css'

export function OnOffStyle02({
  trait,
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const traitToken = String(trait || '').trim().toLowerCase()
  const isStartStopTrait = traitToken === 'startstop'
  const fromState = Boolean(
    state?.on === true || state?.on === 1 || state?.on === 'on' ||
    state?.OnOff === true || state?.OnOff === 1 || state?.OnOff === 'on' ||
    state?.running === true || state?.running === 1 || state?.running === 'running' || state?.running === 'on' ||
    state?.status === 'running' || state?.status === 'RUNNING'
  )
  const [localOverride, setLocalOverride] = useState<boolean | null>(null)

  useEffect(() => {
    setLocalOverride(null)
  }, [fromState])

  const isOn = localOverride ?? fromState
  const stateToken = isStartStopTrait ? (isOn ? 'on start' : 'off stop') : isOn ? 'on' : 'off'

  const handleToggle = () => {
    if (disabled) return
    const next = !isOn
    setLocalOverride(next)
    if (isStartStopTrait) {
      void onCommand(next ? 'start' : 'stop')
      return
    }
    void onCommand(next ? 'on' : 'off')
  }

  return (
    <div className="trait-onoff-style02 trait-stitch-v2-glass">
      <div className="trait-onoff-style02__content">
        <span
          className="trait-onoff-style02__label"
          data-css-slot="powerLabel"
          data-css-slot-label={isStartStopTrait ? 'StartStop Label' : 'Power Label'}
          data-css-state={stateToken}
        >
          {isStartStopTrait ? 'Start Stop' : 'Power State'}
        </span>
        <span
          className="trait-onoff-style02__status"
          data-css-slot="powerStatus"
          data-css-slot-label={isStartStopTrait ? 'StartStop Status' : 'Power Status'}
          data-css-state={stateToken}
        >
          {isStartStopTrait ? (isOn ? 'START' : 'STOP') : isOn ? 'ON' : 'OFF'}
        </span>
      </div>
      <button
        type="button"
        className={`trait-onoff-style02__btn ${isOn ? 'on' : ''}`}
        onClick={handleToggle}
        disabled={disabled}
        data-css-slot="powerButtonSurface"
        data-css-slot-label={isStartStopTrait ? 'StartStop Control' : 'Power Control'}
        data-css-state={stateToken}
      >
        <span
          data-css-slot="powerIcon"
          data-css-slot-label={isStartStopTrait ? 'StartStop Icon' : 'Power Icon'}
          data-css-state={stateToken}
        >
          <span className="material-symbols-outlined">power_settings_new</span>
        </span>
      </button>
    </div>
  )
}
